export const MAX_AREAS = 30;
export const MAX_PINS = 30;
export const TOUCH_SCREEN_OFFSET = 50;
